import { useQuery } from '@apollo/react-hooks';
import { scheduledSuppliers } from './queries.graphql';

export function useScheduledSuppliers(variables) {
  return useQuery(scheduledSuppliers, {
    variables
  });
}
